<div class="footer" [class.asOverlay]="justOverlay" *ngIf="!hidden" role="contentinfo">
  <div>
    <ng-container *ngIf="!isEmbed && !justOverlay">
      <span class="copyright">2024 - {{ lawFirmName }}</span>
      <span class="important-links">
        <a [href]="imprintLink" target="_blank" *ngIf="imprintLink">{{
          "common.label.imprint" | translate
          }}</a>
        <a [href]="dseLink" target="_blank" *ngIf="dseLink">{{
          "common.label.dse" | translate
          }}</a>
      </span>
    </ng-container>
  </div>
  <div class="language-select" [matMenuTriggerFor]="languageMenu" *ngIf="!auth?.loggedIn || !auth.isClient">
    <span [ngClass]="[
       'fi',
        'fi-' +
         (translator.currentLang === 'en' ? 'gb' : translator.currentLang) ]" aria-hidden="true"></span><span>{{
      translator.currentLang | uppercase }}</span>
    <mat-icon aria-hidden="true">expand_less</mat-icon>
  </div>
  <mat-menu #languageMenu="matMenu">
    <ng-container *ngFor="let language of languages">
      <button mat-menu-item *ngIf="language !== translator.currentLang" (click)="selectLanguage(language)">
        <span [ngClass]="['fi', 'fi-' + (language === 'en' ? 'gb' : language)]" aria-hidden="true"></span>
        {{ language | uppercase }}
      </button>
    </ng-container>
  </mat-menu>
  <div>
    <div class="poweredby" *ngIf="customLogo">
      <img src="assets/LogoIcon@1.svg" [alt]="'alt.companyLogo' | translate" />
      <img src="assets/Logo.svg" [alt]="'alt.companyLogoAndName' | translate" />
    </div>
  </div>
</div>